import * as angular from 'angular';

"use strict";

angular.module('ExportModule', [])

export default 'ExportModule';